import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-achats',
    templateUrl: './achats.component.html',
    styleUrls: ['./achats.component.css'],
    standalone: false
})
export class AchatsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
